























import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectManagerTableItem from "@/viewmodels/project-manager-table-item";
import { isNewProject } from "@/preferences";

@Component({
  props: {
    selectable: Boolean,
    removable: Boolean
  },
  methods: {
    isNewProject
  }
})
export default class ProjectManagerTable extends Vue {
  @Prop({ default: () => [] }) selectedIds!: number[];
  @Prop({ default: () => [] }) items!: ProjectManagerTableItem[];
  @Prop({ default: () => false }) customField!: boolean;

  get fields() {
    let fields = [
      { key: "name", label: "名前" },
      { key: "tel", label: "電話番号" },
      { key: "email", label: "メール" },
      { key: "type", label: "職種" },
      { key: "belongsTo", label: "支店" },
      { key: "actions", label: "" }
    ];
    if (this.$props.selectable) {
      fields.unshift({ key: "id", label: "" });
    }

    if (this.customField) {
      const extraFields = [];

      if (isNewProject(this.project.created)) {
        extraFields.push({ key: "responsiblePerson", label: "責任者" });
      }

      extraFields.push({ key: "scheduleNotification", label: "チャット通知" });
      fields.splice(1, 0, ...extraFields);
    }

    return fields;
  }

  get currentSelectedIds(): number[] {
    return this.selectedIds;
  }

  set currentSelectedIds(selectedIds: number[]) {
    this.$emit("select", selectedIds);
  }

  remove(id: number) {
    this.$emit("remove", id);
  }

  // custom class for tbody tr
  setTbodyTrClass(item: any) {
    const classes = [];
    if (item.isHiddenInfo === 1) classes.push("table-secondary");
    return classes;
  }

  get project() {
    return this.$store.state.project;
  }
}
